var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "data-value copy-element" },
    [
      _c(
        "CompassLink",
        {
          attrs: { label: _vm.email, link: "javascript:;" },
          on: { click: _vm.emailClicked }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("Clipboard", { attrs: { data: _vm.email } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }